export default class MunicpalityModel {
    idMunicipio : number | null;
    fkNProvincia: number | null;
    fldTMunicipioEndonimo: string | null;
    fldTMunicipioExonimo: string | null;

    constructor() {
        this.idMunicipio = null;
        this.fkNProvincia = null;
        this.fldTMunicipioEndonimo = null;
        this.fldTMunicipioExonimo = null;
    }
}